import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";
/**
 * the funtion follow Luhn algorithm
 * Wiki: https://en.wikipedia.org/wiki/SIM_card#ICCID
 *
 * @param code the digit string need to check
 * @returns boolean
 */
export const checksum = code => {
    if (/^\d+$/.test(code)) {
        let sum = 0;
        let even = false;
        for (let i = code.length - 1; i >= 0; i--) {
            let d = +code.charAt(i);
            if (even) {
                d *= 2;
                if (d > 9) {
                    d -= 9;
                }
            }
            sum += d;
            even = !even;
        }
        return sum % 10 === 0;
    }
    return false;
};
export const checksumValid = (control: FormControl) => {
    if (!control.value && control.value !== 0) {
        return null;
    }
    return checksum(control.value) ? null : { checksum: messages.validation.checksum };
};
